//@ts-nocheck
import escapeHtml from 'escape-html';
import { Text, Descendant } from 'slate';
import { CustomText } from '../../../lib/utils/types/slate';
import { Mention, MergeField } from '../../../lib/types';
import { addBlockStyling } from './addBlockStyling';

export const serialize = (raw: Descendant[]) => {
	if (Array.isArray(raw) === false) return raw as string;
	return raw.map(node => serializeNode(node)).join('');
};

export const serializeNode = (node: Descendant): string => {
	if (Text.isText(node)) {
		const styledNode = addBlockStyling((node as unknown) as CustomText);
		return styledNode;
	}

	const children = node.children
		.map((childNode: Descendant) => serializeNode(childNode))
		.join('');

	switch (node.type) {
		case 'bulleted-list':
			return `<ul>${children}</ul>`;
		case 'link':
			return `<a target='_blank' rel='noreferrer' href="${escapeHtml(
				node.href as string,
			)}">${children}</a>`;
		case 'mention':
			const mention = node.metadata as Mention['metadata'];
			const metadata = JSON.stringify(mention);
			return `<mention data-metadata='${metadata}' data-${mention.type}-id="${mention._id}">${mention.text}</mention>`;
		case 'merge-field':
			const mergeField = node.metadata as MergeField['metadata'];
			const mergeFieldMetaData = JSON.stringify(mergeField);
			return `<mergefield value='${mergeField.key}' data-metadata='${mergeFieldMetaData}'>${mergeField.label}</mergefield>`;
		case 'block-quote':
			return `<blockquote>${children}</blockquote>`;
		case 'heading-one':
			return `<h1>${children}</h1>`;
		case 'list-item':
			return `<li>${children}</li>`;
		case 'numbered-list':
			return `<ol>${children}</ol>`;
		case 'paragraph':
			return `<p>${children}</p>`;
		default:
			return children;
	}
};
